<p>next-available-block works!</p>
